'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$UploadFileRequest(origin, text) {
  this.Cl = null;
  this.JK = null;
  this.Cl = origin;
  this.JK = text;
}
export { $c_Lpresto_AgentView$UploadFileRequest as $c_Lpresto_AgentView$UploadFileRequest };
$p = $c_Lpresto_AgentView$UploadFileRequest.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$UploadFileRequest;
/** @constructor */
function $h_Lpresto_AgentView$UploadFileRequest() {
}
export { $h_Lpresto_AgentView$UploadFileRequest as $h_Lpresto_AgentView$UploadFileRequest };
$h_Lpresto_AgentView$UploadFileRequest.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_AgentView$UploadFileRequest) && ((this.Cl === x$0.Cl) && (this.JK === x$0.JK))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "UploadFileRequest";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Cl;
  }
  if ((n === 1)) {
    return this.JK;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.pv = (function() {
  return this.Cl;
});
function $isArrayOf_Lpresto_AgentView$UploadFileRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hM)));
}
export { $isArrayOf_Lpresto_AgentView$UploadFileRequest as $isArrayOf_Lpresto_AgentView$UploadFileRequest };
var $d_Lpresto_AgentView$UploadFileRequest = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$UploadFileRequest, "presto.AgentView$UploadFileRequest", ({
  hM: 1,
  b5: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_AgentView$UploadFileRequest as $d_Lpresto_AgentView$UploadFileRequest };
//# sourceMappingURL=presto.-Agent-View$-Upload-File-Request.js.map
